import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import 'react-select/dist/react-select.css';
import { Text } from 'components/styled/ui';
import { images } from 'config';
import { Content, Header, Body } from './styles';
import $ from 'jquery';
import Checkbox from '../checkboxTree/checkbox';
import { strings } from 'config';
import { numberTranslate } from 'utils';

class PublishedDates extends Component {
  constructor() {
    super();

    this.state = {
      selectedFilter: [],
      documentTypes: []
    };
  }

  componentDidMount() {
    this.slideToggleContent();
  }

  slideToggleContent() {
    let self = this;
    $(ReactDOM.findDOMNode(this.refs.typesGroup))
      .find('.header')
      .click(function() {
        $(ReactDOM.findDOMNode(self.refs.typesGroup)).toggleClass('expanded');
      });
  }

  componentWillReceiveProps(nextProps) {
    const { data, filters } = nextProps;
    if (this.state.documentTypes !== data) {
      this.setState({
        documentTypes: data
      });
    }

    this.setState({
      selectedFilter: filters.publishedDates
    });
  }

  getFilteredData = data => {
    if (data) {
      return data.map(val => {
        return { label: val, value: val };
      });
    } else {
      return [];
    }
  };

  onChange = val => {
    const { onDatesChange } = this.props;

    let { value } = val;
    let selectedFilter = this.state.selectedFilter;

    let index = selectedFilter.indexOf(value);
    if (index !== -1) {
      selectedFilter.splice(index, 1);
    } else {
      selectedFilter.push(value);
    }
    this.setState({ selectedFilter });
    onDatesChange(selectedFilter);
  };

  render() {
    const { documentTypes } = this.state;
    const data = this.getFilteredData(documentTypes);
    const { dataList } = this.props;

    return (
      <Content ref="typesGroup">
        <Header className="header">
          <Text.span size={14}>{strings.filters.publishedDates}</Text.span>
          <img className="icon" src={images.icons.downArrow} alt="Down arrow" />
        </Header>
        <Body className="filters">
          {data.map((val, index) => (
            <Checkbox
              filter="publishedDate"
              dataList={dataList}
              key={index}
              title={val.label}
              titleNp={numberTranslate(val.label)}
              checked={this.state.selectedFilter.includes(val.value)}
              value={val.value}
              onChange={() => this.onChange(val)}
            />
          ))}
        </Body>
      </Content>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters
  };
};

export default connect(mapStateToProps)(PublishedDates);



// WEBPACK FOOTER //
// ./src/components/layouts/advancedFilters/publishedDates.js